// SETS
export const SET_DOCUMENT_TYPES_ERROR = 'SET_DOCUMENT_TYPES_ERROR';
export const SET_DOCUMENT_TYPES_LIST = 'SET_DOCUMENT_TYPES_LIST';
export const SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES = 'SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES';
export const SET_FETCHING_DOCUMENT_TYPES = 'SET_FETCHING_DOCUMENT_TYPES';
export const SET_DOCUMENT_TYPES_SHOW_MODAL = 'SET_DOCUMENT_TYPES_SHOW_MODAL';
export const SET_DOCUMENT_TYPES_ADD_ERROR = 'SET_DOCUMENT_TYPES_ADD_ERROR';
export const SET_DOCUMENT_TYPES_ADD_SUCCESS = 'SET_DOCUMENT_TYPES_ADD_SUCCESS';
export const SET_DOCUMENT_TYPES_ADD_FETCHING = 'SET_DOCUMENT_TYPES_ADD_FETCHING';
